import React from 'react';
import { Link } from "react-router-dom";
import * as Backend from '../backend.js';
import * as util from '../other/util.js';

// Lists all chats for the player
class ChatOverview extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        Backend.getChatOverview((chat) => {
            this.setState({ chat: chat });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let chat = this.state.chat;
        return (
            <div className="fade-in" key={Math.random()}>
                <h1>Conversations</h1>
                <Link className="link-button" to={{ pathname: '/game/chat-compose', force_update: true }}>
                    Compose Message </Link>

                <h2>New Messages {chat.unread_count === 0 ? "" : (" (" + chat.unread_count + ")")}</h2>
                <p className="boring-info-text">Commander, all active correspondences with other empires and your
                    advisors can be found here. For your convenience the most recent once are on top.</p>
                {this.renderBox(chat.new_chats)}

                <h2>Archived Messages</h2>
                <p className="boring-info-text">This is the great chat archive, Sir! You can move chats here (NOT
                    IMPLEMENTED YET) that are no longer relevant to you.
                    When there is a new development in one of your archived chats, it is automatically moved to the "New
                    Chats" section.
                    In case you might forget something someone said you can always check here. Not that I am saying you
                    ever
                    forget, Sir!</p>
                {this.renderBox(chat.all_chats)}
                <br />
                <util.JsonDebug obj={chat} />
            </div>
        );
    }

    renderBox(box) {
        if (box.chats.length === 0) {
            return (<div key={box.name} style={{ textAlign: "center" }}>{"<<EMPTY>>"}</div>);
        }

        return (
            <table className="generic-list">
                <thead style={{ fontSize: "14px" }}>
                    <tr>
                        <td />
                        <td>Sender</td>
                        <td>Subject</td>
                        <td>Last Message</td>
                    </tr>
                </thead>
                <tbody>
                    {box.chats.slice().reverse().map((chat) => (this.renderChat(chat)))}
                </tbody>
            </table>
        );
    }

    renderChat(chat) {
        return (
            <tr key={chat.id}>
                <td style={{ textAlign: "center" }}>{chat.unread_count === 0 ? "" : chat.unread_count}</td>
                <td>{chat.last_sender_name}</td>
                <td>{this.renderChatLink(chat.id, chat.subject)}</td>
                <td>{new Date(chat.last_message_time_stamp).toLocaleString()}</td>
            </tr>
        )
    }

    renderChatLink(chat_id, subject) {
        return (
            <div style={{ display: "inline" }}>
                <Link className="link-button"
                    to={{
                        pathname: '/game/chat/' + chat_id,
                        force_update: true
                    }}>{subject}
                </Link>
            </div>
        )
    }
}

export default util.withNavigation(ChatOverview);